import React from 'react';
import { useSpacing } from '../../api/spacing/useSpacing';
import { pickComponentCommonProps } from '../../interfaces/commonProps';
import { StyledLayout } from './Layout.styles';
import { layoutPropTypes } from './Layout.types';
export const Layout = React.forwardRef(({ children, align, direction, justify, wrap, ...restProps }, ref) => {
    return (React.createElement(StyledLayout, { outerSpacing: useSpacing(restProps), align: align, direction: direction, justify: justify, ref: ref, wrap: wrap, ...pickComponentCommonProps(restProps) }, children));
});
Layout.displayName = 'Layout';
Layout.propTypes = layoutPropTypes;
//# sourceMappingURL=Layout.js.map